import { X } from "@untitledui/icons";
import type React from "react";
import { Dialog, Heading, Modal, ModalOverlay } from "react-aria-components";

export function Drawer({
  isOpen,
  onClose,
  children,
  title,
  label,
}: {
  isOpen: boolean;
  onClose: (open: boolean) => void;
  children: React.ReactNode;
  title?: string;
  label?: string;
}) {
  return (
    <ModalOverlay
      isOpen={isOpen}
      onOpenChange={onClose}
      className={`
        fixed inset-0 z-50 bg-black/50 backdrop-blur-sm
        transition-opacity duration-200 ease-out
        data-entering:opacity-0
        data-entered:opacity-100
        data-exiting:opacity-0 max-w-screen-sm mx-auto
      `}
      isDismissable
    >
      <Modal
        className={`
          fixed bottom-0 left-0 right-0 z-50
          transition-transform duration-300 ease-out
          data-entering:translate-y-full
          data-entered:translate-y-0
          data-exiting:translate-y-full
        `}
      >
        <Dialog
          aria-label={title ? undefined : label}
          className="
            bg-white rounded-t-2xl shadow-2xl
            max-h-[80vh] overflow-hidden
            focus:outline-none
          "
        >
          {/* Handle bar */}
          {/* <div className="flex justify-center p-2">
            <div className="w-12 h-1 bg-gray-300 rounded-full" />
          </div> */}

          {/* Header */}
          {title && (
            <div className="px-6 py-4 border-b border-gray-200">
              <Heading
                slot="title"
                className="text-lg text-center font-semibold text-gray-900"
              >
                {title}
              </Heading>
              <X
                className="absolute top-4 right-4 h-6 w-6 cursor-pointer text-gray-500 hover:text-gray-700"
                onClick={() => onClose(false)}
              />
            </div>
          )}

          {/* Content */}
          <div className="p-6 overflow-y-auto max-h-[calc(80vh-4rem)]">
            {children}
          </div>
        </Dialog>
      </Modal>
    </ModalOverlay>
  );
}
